import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {Input} from 'wobi-web-common/dist/v2/index.js';

export function DeviceFields({traveler, index, formikErrors, onUpdate, showYear = false}) {
  const intl = useIntl();
  const theme = useTheme();
  const pc = traveler.pc || {};
  const mobile = traveler.mobile || {};
  const isPC = showYear;
  const item = isPC ? pc : mobile;
  const itemKey = isPC ? 'pc' : 'mobile';

  const getError = (field) => {
    const errorId = formikErrors?.travelers?.[index]?.[itemKey]?.[field];
    return errorId ? intl.formatMessage({id: errorId}) : '';
  };

  return (
    <div data-testid={`${itemKey}coverDeviceFields${index + 1}`} style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      marginTop: 10,
    }}>
      <div>
        <div style={{fontSize: theme.typography.pxToRem(12.5), color: theme.palette.text.secondary, textAlign: 'center', marginBottom: 6, fontWeight: theme.typography.fontWeightSemiBold}}>
          <FormattedMessage id='step1.tab5.pccover_bottom2_manufacturer'/>
        </div>
        <Input
          value={item.manufacturer || ''}
          onChange={(e) => onUpdate(index, 'manufacturer', itemKey, e.target.value)}
          placeholder={intl.formatMessage({id: 'step1.tab5.pccover_bottom2_manufacturer'})}
          style={{textAlign: 'center'}}
          data-testid={`${itemKey}coverManufacturer${index + 1}`}
        />
        {getError('manufacturer') && <div style={{fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main, marginTop: 4, textAlign: 'center'}}>{getError('manufacturer')}</div>}
      </div>
      <div>
        <div style={{fontSize: theme.typography.pxToRem(12.5), color: theme.palette.text.secondary, textAlign: 'center', marginBottom: 6, fontWeight: theme.typography.fontWeightSemiBold}}>
          <FormattedMessage id='step1.tab5.pccover_bottom2_model'/>
        </div>
        <Input
          value={item.model || ''}
          onChange={(e) => onUpdate(index, 'model', itemKey, e.target.value)}
          placeholder={intl.formatMessage({id: 'step1.tab5.pccover_bottom2_model'})}
          style={{textAlign: 'center'}}
          data-testid={`${itemKey}coverModel${index + 1}`}
        />
        {getError('model') && <div style={{fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main, marginTop: 4, textAlign: 'center'}}>{getError('model')}</div>}
      </div>
      {showYear && (
        <div>
          <div style={{fontSize: theme.typography.pxToRem(12.5), color: theme.palette.text.secondary, textAlign: 'center', marginBottom: 6, fontWeight: theme.typography.fontWeightSemiBold}}>
            <FormattedMessage id='step1.tab5.pccover_bottom2_year'/>
          </div>
          <Input
            value={item.year || ''}
            onChange={(e) => onUpdate(index, 'year', itemKey, e.target.value)}
            placeholder="YYYY"
            inputMode="numeric"
            style={{textAlign: 'center'}}
            data-testid={`${itemKey}coverYear${index + 1}`}
          />
          {getError('year') && <div style={{fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main, marginTop: 4, textAlign: 'center'}}>{getError('year')}</div>}
        </div>
      )}
    </div>
  );
}
